/*
 *  Copyright 2014 NHN Entertainment Corp. All rights Reserved.
 *  NHN Entertainment PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 *
 *   @author changyoun.seo@nhnedu.com
 *   @since 21. 2. 15. 오후 5:25
 *   @desc
 */

import './css/common.css';
import './css/intro.css';
import './css/intro_custom.css';

import AOS from 'aos';
import 'aos/dist/aos.css';
import $ from '@/assets/js/utils/jquery';
import 'slick-carousel';
import 'waypoints/lib/jquery.waypoints';
import 'jquery.counterup';
import '@/assets/js/utils/only-phone-number';
import AppSms from '@/assets/js/utils/app-sms';
import AppSearch from '@/assets/js/utils/app-search';
import '@/assets/js/utils/app-popup';
import {switchByUserAgent} from '@/assets/js/utils/userAgentHelper';

$('.unione-only-phonenumber').onlyPhoneNumber();

$(window).on('load', () => {
    AOS.init();
    $('.part_inline').addClass('animated');
});

$(window).scroll(() => {
    toggleHeader();
});

applySlick();
applyCountUp();
const noticeAnimation = noticeAnimationGenerator();
noticeAnimation.init();
$('section.notice').waypoint({
    handler() {
        noticeAnimation.run();
        this.destroy();
    },
    offset: '40%',
});
$('section.edu_content').waypoint(applyContentsSpreadAnimation, {offset: '30%'});

switchByUserAgent();

// 학교 검색
new AppSearch({
    $form: $('#searchForm'),
    $input: $('#search'),
    $resultArea: $('#resultArea'),
    $listArea: $('#listArea'),
    $noResultArea: $('#noResultArea'),
    $layerArea: $('#searchLayerArea'),
    listTemplate: '<li><a href="/organization/<%= instituteNo %>" class="link_school" target="_blank"><em class="name_school"><%= name %></em><%= address %></a></li>',
});

// SNS 발송
AppSms({
    $button: $('#smsButton'),
    $phone: $('#cellp'),
    $agree: $('#agree'),
    serviceType: 'IAMSCHOOL',
});

function applySlick() {
    const INTRO_SLIDE_OPTIONS = {
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 1000,
        fade: true,
        cssEase: 'linear',
        dots: true,
        dotsClass: 'tab_preview',
        pauseOnFocus: false,
        pauseOnHover: false,
        customPaging: function (slider, i) {
            return '<button class="tab' + (i + 1) + '">' + '<span class="txt">' + $(slider.$slides[i])
                .attr('title') + '</span>' + '</button>';
        },
        rows: 0,
    };

    const STORE_SLIDE_SPEED = 2000;
    const STORE_SLIDE_OPTIONS = {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: STORE_SLIDE_SPEED,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        pauseOnFocus: false,
        pauseOnHover: false,
        rows: 0,
        // rtl: true // reverse
    };

    const CLASS_SLIDE_OPTIONS = {
        accessibility: false,
        draggable: false,
        touchMove: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: 'linear',
        infinite: true,
        variableWidth: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        rows: 0,
    };

    $('.bx_slide_double').eq(0).slick(STORE_SLIDE_OPTIONS);
    setTimeout(() => $('.bx_slide_double').eq(1).slick(STORE_SLIDE_OPTIONS), STORE_SLIDE_SPEED / 2);
    $('.bx_slide_academy').slick(CLASS_SLIDE_OPTIONS);

    const introSlider = $('.cont_preview').slick(INTRO_SLIDE_OPTIONS);
    introSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
        if (currentSlide === 0) {
            // 한바퀴 돌았으면
            slick.slickSetOption('autoplay', false, false);
        }
    });
}

let isHeaderFixed = false;

function toggleHeader() {
    if ($(window).scrollTop() > 10) {
        if (!isHeaderFixed) {
            $('[data-header]').addClass('fixed_header');
        }
        isHeaderFixed = true;
    } else {
        if (isHeaderFixed) {
            $('[data-header]').removeClass('fixed_header');
        }
        isHeaderFixed = false;
    }
}

function applyCountUp() {
    $('[data-countup]').counterUp({
        delay: 10,
        time: 1500,
    });
}

function noticeAnimationGenerator() {
    let eventId = null;
    let isClickable = true;

    const DURATION = 2000;
    const CENTER_OF_SLIDE = 8;
    const ITEMS = [
        {
            index: 0,
            contents: '알림장',
            backgroundColorList: ['rgba(158,255,229,0.16)', 'rgba(158,255,229,0.1)', 'rgba(158,255,229,0.1)', 'rgba(158,255,229,0.1)'],
        }, {
            index: 1,
            contents: '설문',
            backgroundColorList: ['rgba(186,252,255,0.16)', 'rgba(186,252,255,0.1)', 'rgba(186,252,255,0.1)', 'rgba(186,252,255,0.1)'],
        }, {
            index: 2,
            contents: '급식',
            backgroundColorList: ['rgba(255,230,213,0.16)', 'rgba(255,230,213,0.1)', 'rgba(255,230,213,0.1)', 'rgba(255,230,213,0.1)'],
        }, {
            index: 3,
            contents: '주간학습',
            backgroundColorList: ['rgba(255,255,177,0.16)', 'rgba(255,255,177,0.1)', 'rgba(255,255,177,0.1)', 'rgba(255,255,177,0.1)'],
        }, {
            index: 4,
            contents: '가정통신문',
            backgroundColorList: ['rgba(255,217,255,0.16)', 'rgba(255,217,255,0.1)', 'rgba(255,217,255,0.1)', 'rgba(255,217,255,0.1)'],
        }, {
            index: 5,
            contents: '학원 알림장',
            backgroundColorList: ['rgba(235,220,255,0.16)', 'rgba(235,220,255,0.1)', 'rgba(235,220,255,0.1)', 'rgba(235,220,255,0.1)'],
        }, {
            index: 6,
            contents: '방과후교육',
            backgroundColorList: ['rgba(218,228,255,0.16)', 'rgba(218,228,255,0.1)', 'rgba(218,228,255,0.1)', 'rgba(218,228,255,0.1)'],
        }, {
            index: 7,
            contents: '상담',
            backgroundColorList: ['rgba(248,224,255,0.16)', 'rgba(248,224,255,0.1)', 'rgba(248,224,255,0.1)', 'rgba(248,224,255,0.1)'],
        },
    ];
    const RIPPLE_SCALES = [
        {className: 'scale--level1'},
        {className: 'scale--level2'},
        {className: 'scale--level3'},
        {className: 'scale--level4'},
    ];

    function moveToNext() {
        $('[data-ani=notice]').prepend($('[data-ani=notice] div:last-child'));
    }

    function moveToPrev() {
        $('[data-ani=notice]').append($('[data-ani=notice] div:first-child'));
    }

    /**
     * 핸드폰 이미지 기준 좌측인지 우측인지
     *
     * @param index
     * @returns {boolean}
     */
    function isLeftSide(index) {
        return index <= (CENTER_OF_SLIDE);
    }

    function getCurrentIndex() {
        return +$('[data-ani=notice] div').eq(CENTER_OF_SLIDE).data('index');
    }

    function applyRolling() {
        eventId = setInterval(() => {
            moveToNext();
            setContents(getCurrentIndex());
        }, DURATION);
    }

    function stopRolling() {
        if (eventId) {
            clearInterval(eventId);
        }
    }

    function setContents(index) {
        const item = ITEMS[index];
        setPhoneBackground(item.index);
        setRipple(item.backgroundColorList);
    }

    function setPhoneBackground(index) {
        let $imageList = $('[data-ani=phone] img');
        $imageList.hide();
        $imageList.eq(index).show();
    }

    function setRipple(backgroundColorList) {
        const $rippleList = $('[data-ani=ripple] div');
        $rippleList.each(index => {
            $rippleList.eq(index).css('background-color', backgroundColorList[index]);
            $rippleList.eq(index).addClass(RIPPLE_SCALES[index].className);
        });
        setTimeout(() => {
            $rippleList.removeClass((index, className) => (className.match(/scale\S+/g) || []).join(' '));
        }, 700);
    }

    function applySlideEvent() {
        const $slideList = $('[data-ani=notice] div');

        $slideList.on('mouseenter', stopRolling);
        $slideList.on('mouseleave', applyRolling);

        $slideList.on('click', event => {
            if (!isClickable) {
                return;
            }

            isClickable = false;
            setTimeout(() => {
                isClickable = true;
            }, 800);

            const targetIndex = +$(event.currentTarget).data('index');
            let currentIndex = getCurrentIndex();
            const moveToByDirection = isLeftSide($(event.currentTarget).index()) ? moveToNext : moveToPrev;

            let safety = 0;
            while (targetIndex !== currentIndex) {
                moveToByDirection();
                currentIndex = getCurrentIndex();
                safety++;
                if (safety > 100) {
                    return;
                }
            }

            setContents(currentIndex);
        });
    }

    return {
        init() {
            setContents(getCurrentIndex());
        },
        run() {
            applySlideEvent();
            applyRolling();
        },
    };
}

function applyContentsSpreadAnimation() {
    $('[data-ani=spread]').addClass('animated');
}
